import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import FieldSelector from 'components/FieldSelector/FieldSelector';

var ActiveInactive = function (props) {
  var config = props.config;
  var settingsFields = props.settingsFields;
  var errors = props.errors || {};
  var t = useTranslation().t;

  var handleFieldChange = function (suuid, title) {
    props.onActiveFieldChange(suuid, title);
  };

  return (
    <div className="inspect-section-active-inactive">
      <div className="inspect-settings-content-header">
        <h3 className="inspect-settings-content-title">{t('inspect:sectionActiveInactive')}</h3>
        <p className="inspect-settings-content-description">{t('inspect:activeInactiveDescription')}</p>
      </div>
      <FieldSelector
        currentSUUID={config.activeFieldKey || ''}
        fields={settingsFields}
        onChange={handleFieldChange}
        filterType="boolean"
        error={!!errors.isActiveFieldPathHash}
      />
      {errors.isActiveFieldPathHash && (
        <div className="slate-text-input-error">{errors.isActiveFieldPathHash}</div>
      )}
      <p className="inspect-mode-hint">{t('inspect:activeInactiveScopeHint')}</p>
    </div>
  );
};

ActiveInactive.propTypes = {
  config: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  settingsFields: PropTypes.array.isRequired,
  onActiveFieldChange: PropTypes.func.isRequired,
};

export default ActiveInactive;
